export const englishWordsRegExp = /[a-z]+/gi
export const englishLettersRegExp = /[a-z]/gi
export const englishLetterRegExp = /[a-z]/i

export const excludeNumbersWithDotRegExp = /[^0-9.]/g

export const analyticsCalculatorRegExp = /[^0-9.\W\w()\-+\/*\s]/i

export const mathSymbolsRegExp = /[^0-9.()\-+/*]/i
